import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
// import { JobsDataModel } from '../jobs-data-model';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { CommonService } from 'src/app-core/services/common.service';
import { CommonDataModel } from 'src/app/shared/common-data-model';
@Component({
  selector: 'app-orders-bulk-status-change-form',
  templateUrl: './orders-bulk-status-change-form.component.html',
  styleUrls: ['./orders-bulk-status-change-form.component.scss']
})
export class OrdersBulkStatusChangeFormComponent implements OnInit {
  ordersDataModel = new CommonDataModel();
  bulkStatusUpdateModel = this.ordersDataModel.ordersBulkStatusUpdateModel;
  jobsData: any;
  isFormLoading = false;
  selectedStatus: null;
  selectedStatusName: null;
  note: string;
  statusList: Array<any>;
  JobIds: [];
  isJob: any;
  minDate = moment().subtract(3, 'weeks').format();
  isStatusLost = false;

  constructor(
    public dialog: MatDialog,
    private commonService: CommonService,
    private router: Router,
    private toastr: ToastrService,
    public dialogRef: MatDialogRef<OrdersBulkStatusChangeFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.isJob = (this.router.url.indexOf('/quotes-list') !== -1) ? false : true;
    this.JobIds = data;
  }

  ngOnInit() {
    this.onLoadItems();
    this.jobsData = this.data;
    this.getOrderStatus();
    if (this.bulkStatusUpdateModel.statusId === 8) {
      this.minDate = moment().subtract(3, 'months').format();
    }
  }

  onLoadItems() {
    this.bulkStatusUpdateModel.serviceDate = moment().format();
    this.bulkStatusUpdateModel.serviceTime = moment().format();
  }

  getOrderStatus() {
    this.commonService.getOrderStatus(`IsJob=${this.isJob}`).subscribe((response: any) => {
      if (this.isJob) {
        this.statusList = response.data.filter(item => item.id !== 9 && item.id !== 10 && item.id !== 11);
      } else {
        this.statusList = response.data;
      }
    });
  }

  onChangeStatus(event: any) {
    this.selectedStatusName = event.name;
    if (this.selectedStatusName == 'Lost') {
      this.isStatusLost = true;
    }
    else {
      this.isStatusLost = false;
    }
  }

  onSubmit() {
    this.bulkStatusUpdateModel.serviceDate = moment(this.bulkStatusUpdateModel.serviceDate).format();
    this.bulkStatusUpdateModel.orderId = this.JobIds;
    this.bulkStatusUpdateModel.notes = this.note;
    this.bulkStatusUpdateModel.statusId = this.selectedStatus;
    this.bulkStatusUpdateModel.statusName = this.selectedStatusName;
    this.bulkStatusUpdateModel.serviceTime = moment(this.bulkStatusUpdateModel.serviceTime).format('HH:mm:ss');
    this.isFormLoading = true;
    this.commonService.orderBulkUpdate(this.bulkStatusUpdateModel)
      .pipe(finalize(() => (this.isFormLoading = false))).subscribe((response: any) => {
        this.isFormLoading = false;
        if (response.isSuccess) {
          //   this.statusList = response.data;
          this.toastr.success(response.errors || 'Updated successfully');
          this.dialogRef.close(true);
        } else {
          this.toastr.error(response.errors || 'Something went wrong please Re-try', 'Error!');
        }
      });
  }

  onClose(): void {
    this.dialogRef.close(false);
  }

}
